<template>
  <button
    v-if="!isMenuOpen"
    class="flex h-8 w-8 items-center justify-center hover:rounded hover:bg-blue-400/10"
    :title="t('search-menu.placeholder')"
    @click="handleClick"
  >
    <IconSearch class="h-6 w-6 text-blue-400" />
  </button>
</template>

<script setup lang="ts">
  const { t } = useI18n();
  const searchMenuStore = useSearchMenuStore();
  const { isMenuOpen } = storeToRefs(searchMenuStore);

  const handleClick = (): void => {
    isMenuOpen.value = true;
  };
</script>
